module.exports = __webpack_public_path__ + "static/media/_DSC1875.5b15595a.jpg";